import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../routes/path';
import { SparklesIcon, XMarkIcon } from '@heroicons/react/24/outline';

const UpgradeModal = ({ isOpen, onClose, message, limit, currentCount, requiredFeature }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
        
        {/* Header Graphic */}
        <div className="bg-gradient-to-br from-[#dc343b] to-[#ff6b6b] p-6 text-center relative">
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
          
          <div className="w-16 h-16 bg-white/20 rounded-2xl mx-auto flex items-center justify-center mb-4">
            <SparklesIcon className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-2xl font-extrabold text-white tracking-tight">Upgrade Required</h2>
          <p className="text-white/80 text-sm mt-2 font-medium">Unlock more power for your business</p>
        </div>

        {/* Content */}
        <div className="p-6 text-center">
          <p className="text-gray-700 dark:text-gray-300 mb-6 text-[15px] leading-relaxed">
            {message || "You've reached the limit on your current plan. Upgrade to access more features."}
          </p>

          {(currentCount !== undefined && limit !== undefined) && (
            <div className="mb-6 bg-gray-50 dark:bg-gray-800 p-4 rounded-xl border border-gray-100 dark:border-gray-700">
              <div className="flex justify-between text-[13px] font-bold mb-2">
                <span className="text-gray-600 dark:text-gray-400">Usage Limit Reached</span>
                <span className="text-[#dc343b] dark:text-red-400">{currentCount} / {limit}</span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                <div className="bg-[#dc343b] h-2 rounded-full" style={{ width: '100%' }}></div>
              </div>
            </div>
          )}

          <div className="flex gap-3">
            <button 
              onClick={onClose}
              className="flex-1 px-4 py-3 text-gray-600 dark:text-gray-400 font-bold hover:bg-gray-50 dark:hover:bg-gray-800 rounded-xl transition-colors"
            >
              Maybe Later
            </button>
            <button 
              onClick={() => {
                onClose();
                navigate(PATHS.PRICING);
              }}
              className="flex-1 px-4 py-3 bg-[#dc343b] hover:bg-[#c42a31] text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all"
            >
              View Plans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
